export default __webpack_public_path__ + "static/media/Dishath.21fbeb01.png";